<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    v-model:open="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form ref="formRef" :model="form" :rules="rules">
      <a-form-item label="岗位名称" name="postName">
        <a-input v-model:value="form.postName" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="岗位编码" name="postCode">
        <a-input v-model:value="form.postCode" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="显示顺序" name="postSort">
        <a-input-number
          v-model:value="form.postSort"
          :min="0"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="状态" name="status">
        <a-radio-group v-model:value="form.status" button-style="solid">
          <a-radio-button
            v-for="(d, index) in statusOptions"
            :key="index"
            :value="parseInt(d.value)"
          >
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="备注" name="remark">
        <a-input
          v-model:value="form.remark"
          placeholder="请输入"
          type="textarea"
          allow-clear
        />
      </a-form-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form>
  </a-drawer>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'

import { getPost, addPost, updatePost } from '@/api/system/post'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        postCode: undefined,
        postName: undefined,
        postSort: 0,
        status: 1,
        remark: undefined,
      },
      open: false,
      rules: {
        postName: [
          { required: true, message: '岗位编码不能为空', trigger: 'blur' },
        ],
        postCode: [
          { required: true, message: '岗位名称不能为空', trigger: 'blur' },
        ],
        postSort: [
          { required: true, message: '显示顺序不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        postCode: undefined,
        postName: undefined,
        postSort: 0,
        status: 1,
        remark: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加岗位'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getPost(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改岗位'
      })
    },
    /** 提交按钮 */
    submitForm: async function () {
      try {
        await this.$refs.formRef.validate()
        this.submitLoading = true
        if (this.form.id !== undefined) {
          await updatePost(this.form)
          this.$message.success('修改成功', 3)
          this.open = false
          $emit(this, 'ok')
        } else {
          await addPost(this.form)
          this.$message.success('新增成功', 3)
          this.open = false
          $emit(this, 'ok')
        }
      } catch (error) {
        return false
      } finally {
        this.submitLoading = false
      }
    },
  },
  emits: ['ok', 'close'],
}
</script>
